<template>
    <v-row dense>
        <v-col cols="12">
            <v-row dense>
                <v-col cols="12" class="text-right">
                    <v-btn v-if="_.size(objFuenteIngreso.idTipoFuenteIngreso) > 0" rounded dark color="primary" @click="onNuevo">Nuevo</v-btn>
                    <ModalDatoActividadEconomicaComponent :load="objFuenteIngresoModal.abrirModal" 
                        :objFuenteIngreso="objFuenteIngreso"
                        :objFuenteIngresoModal="objFuenteIngresoModal" :parametro="parametro"
                        :listGeneral="listGeneral" />
                </v-col>
            </v-row>

            <v-form ref="form_actividad_economica">

                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Profesión *" color="textbox" v-model="objFuenteIngreso.idProfesion"
                            :items="listGeneral.listaProfesion" item-value="idProfesion" item-text="profesion"
                            :rules="requeridoRegla" outlined dense/>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Fuente de Ingreso *" color="textbox"
                            v-model="objFuenteIngreso.idTipoFuenteIngreso" :items="listGeneral.listaTipoFuenteIngreso"
                            item-value="idTipoFuenteIngreso" item-text="fuente" :rules="requeridoRegla"
                            @change="onListarFuentesIngresos" outlined dense/>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field label="Actividad Económica *" color="textbox"
                            v-model="objFuenteIngreso.actEconomica"
                            :rules="_.concat(requeridoRegla,soloLetrasRegla(5,objFuenteIngreso.actEconomica,500))"
                            outlined dense/>
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col cols="12" sm="6"></v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="objFuenteIngreso.busqueda" dense
                            prepend-inner-icon="search"/>
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col cols="12" sm="12">
                        <v-data-table :search="objFuenteIngreso.busqueda" :headers="listGeneral.cabeceraFuenteIngreso"
                            :items="band ? listGeneral.detalleFuenteIngresoInd : listGeneral.detalleFuenteIngresoDep"
                            class="elevation-3">

                            <template v-slot:item.name="{ item }">
                                <v-btn class="ma-2" text icon color="primary" @click="onEditar(item)">
                                    <v-icon small>edit</v-icon>
                                </v-btn>
                            </template>
                            
                            <template v-slot:no-results>
                                Tu búsqueda de "<span v-text="objFuenteIngreso.busqueda"></span>" no arrojó resultados. 
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col cols="12" sm="12" class="text-right mt-3 mb-3">
                        <v-btn outlined rounded color="danger" class="mr-1" @click="previous('objDatosActEco',this.objFuenteIngreso)">Anterior</v-btn>
                        <v-btn rounded dark color="primary" @click="validar">Siguiente</v-btn>
                    </v-col>
                </v-row>

            </v-form>

        </v-col>

    </v-row>
</template>

<script>
    export default {
        name: 'StepperDatoActividadComponent',
        props:{
            cargar:{ type:Boolean, default: false },
            objForm:{ type:Object, default: {} },
            listGeneral:{ type:Object, default: {} },
            parametro:{ type:Object, default: {} }
        },
        inject:['next','previous','onListarCatalogo'],
        components:{
            ModalDatoActividadEconomicaComponent: () => import('@/components/prevencionLavadoActivo/cliente/ModalDatoActividadEconomicaComponent.vue')
        },
        data(){
            return{
                band       : false,
                objFuenteIngreso:{
                    idTipoFuenteIngreso:null,
                    idProfesion:null,
                    actEconomica:''
                },
                // Modal
                objFuenteIngresoModal:{abrirModal :false, mostrar: false,titulo     : 'Nueva Fuente de Ingreso' ,fechaIngreso : moment().format('YYYY-MM-DD')},
                objDate: { abrirDialogo:false },
            }
        },
        watch:{
            cargar(){
                this.listGeneral.listaFuenteIngreso = [];
                if(this.cargar && (_.size(this.listGeneral.detalleFuenteIngresoInd) == 0) && (_.size(this.listGeneral.detalleFuenteIngresoDep) == 0)){
                    this.objFuenteIngreso = _.merge({},this.objFuenteIngreso,_.clone(this.objForm));
                    this.onCargaGeneral();
                }
            }
        },
        methods:{
            onCargaGeneral(){
                this.onListarCatalogo('TIPO_FUENTE_INGRESO','listaTipoFuenteIngreso')
                    .then((r)=>{
                        if (_.size(_.get(r, ['data', 'data'], [])) == 0) throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion);                            
                            this.listGeneral.listaTipoFuenteIngreso = _.filter(this.listGeneral.listaTipoFuenteIngreso,(o) => { return o.visualiza ==  'true' });
                            this.objFuenteIngreso.idTipoFuenteIngreso = this.listGeneral.listaTipoFuenteIngreso[0].idTipoFuenteIngreso;
            
                            return this.onListarCabecera(); 
                    })
                    .then((r)=>{
                        if (_.size(_.get(this.listGeneral, ['listaTipoFuenteIngreso'], [])) == 0) throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion);
                            var keys = ['idCliente','idFormulario','idCertificado','idPoliza','idEstado'];
                            var objeto = _.merge({},_.pick(this.objFuenteIngreso,keys),{opcion : 'LISTAR_DETALLE_INGRESOS'});

                            return axios.post(`${BASE_URI}administrador/prevension-lavado-activo/cliente/listar`,objeto) ;  
                    })
                    .then((r)=>{
                        if (_.size(_.get(r, ['data', 'data'], [])) == 0) throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion);
                            var parametros = ['actividadEconomica','activos','egresoMensual','ingresoMensual','otrosIngresos','pasivos','patrimonio'];
                            this.objFuenteIngreso = _.merge({},this.objFuenteIngreso,_.omit(r.data.data[0],parametros));
                            this.objFuenteIngreso.idProfesion  = _.isNull(this.objFuenteIngreso.idProfesion) ? this.listGeneral.listaProfesion[0].idProfesion : this.objFuenteIngreso.idProfesion;

                            return this.onListarFuentesIngresos('L');      
                    })
                    .catch((e)=>{
                        mensajesAlerta(e,'E');
                    });
            },
            onListarCabecera(){
                this.listGeneral.cabeceraFuenteIngreso = [];
                var error = 'E';
                var objeto = _.merge({},_.pick(this.objFuenteIngreso,['opcion']),{opcion : 'CAB_FUENTE_INGRESO'});
    
                return axios.post(`${BASE_URI}administrador/prevension-lavado-activo/cliente/listar`,objeto)
                        .then((r) => {
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                
                                this.listGeneral.cabeceraFuenteIngreso = r.data.data;
                            return r;
                        })
                        .catch((e)=>{
                            mensajesAlerta(e,error);
                            return e;
                        })
            },
            onListarFuentesIngresos(e){
                if(!_.isUndefined(e)){
                    this.objFuenteIngreso.opcion = 'LISTAR_FUENTE_INGRESO';
                    var error = 'E';

                    var keys = ['opcion','idTipoFuenteIngreso','idProfesion','idFormulario','idCliente','idContratante','idCanton','idEstado'];
                    var objeto = _.pick(this.objFuenteIngreso,keys); 
                    
                    switch (parseInt(this.objFuenteIngreso.idTipoFuenteIngreso)) {
                        case this.parametro.idTipoFuenteIngresoDependiente:
                            this.band = false;
        
                            if(_.size(this.listGeneral.detalleFuenteIngresoDep) == 0){
                                this.listGeneral.detalleFuenteIngresoDep =[];

                                return axios.post(`${BASE_URI}administrador/prevension-lavado-activo/cliente/listar`,objeto)
                                            .then((r) => {
                                                if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                                if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }

                                                    var l = _.map(_.cloneDeep(r.data.data), (v) => {  v.id = _.uniqueId(); v.index = _.toString(v.index); return v; });
                                                    this.$set(this.listGeneral,'detalleFuenteIngresoDep', l);
            
                                                return r;
                                            }).catch((e) => {  
                                                mensajesAlerta(e,error); 
                                                return e;
                                            });
                            }
                            break;
                        case this.parametro.idTipoFuenteIngresoIndependiente:
                            this.band = true;
                            
                            if (_.size(this.listGeneral.detalleFuenteIngresoInd) == 0) {
                                this.listGeneral.detalleFuenteIngresoInd =[];

                                return axios.post(`${BASE_URI}administrador/prevension-lavado-activo/cliente/listar`,objeto)
                                            .then((r) => {
                                                if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                                if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }

                                                    var l = _.map(_.cloneDeep(r.data.data), (v) => { v.id = _.uniqueId(); v.index = _.toString(v.index); return v; });
                                                    this.$set(this.listGeneral,'detalleFuenteIngresoInd',l);
        
                                                return r;
                                            })
                                            .catch((e) => {  
                                                mensajesAlerta(e,error); 
                                            });
                            }
                            break;
                        default:
                            mensajesAlerta(mensajeEstandar.errorPeticion,'E');
                            break;
                    }
                }
            },
            validar(){
                try {
                    if(!this.$refs.form_actividad_economica.validate()) throw mensajeEstandar.corregirInformacion;
                    if((_.size(this.listGeneral.detalleFuenteIngresoDep) == 0) && (_.size(this.listGeneral.detalleFuenteIngresoInd) == 0)) throw mensajeEstandar.fuenteIngreso;
                        // this.$set(this.$parent.$parent.objForm,'objDatosActEco',_.merge({},this.$parent.$parent.objForm.objDatosActEco,this.objFuenteIngreso));
                        this.next('objDatosActEco',this.objFuenteIngreso);
                    
                } catch (error) {
                    mensajesAlerta(error,'I'); 
                }
            },
            onNuevo(){
                this.$set(this,'objFuenteIngresoModal',_.merge({},_.clone(this.objFuenteIngresoModal),{abrirModal: true, new: true }));
            },
            onEditar(objeto,index){
                this.$set(this,'objFuenteIngresoModal',_.merge({},_.clone(this.objFuenteIngresoModal),objeto,{abrirModal: true, new: false }));
            },
            actualizarDataTable(nombreLista,lista){
                this.$set(this.listGeneral,nombreLista,lista);
                this.$forceUpdate();
            },
            getObjeto(arrayKey,objeto){
                var obj = {};
                _.forEach(arrayKey, (v) => {
                    _.set(obj,v,_.get(objeto,v)); 
                });
                return obj;
            },
            setData(namekey,list,array=true){
                if(array)
                    this.$set(this.listGeneral,namekey,list)    
            },
            resetModal(){
                this.objFuenteIngresoModal = {abrirModal :false, mostrar: false,titulo : 'Nueva Fuente de Ingreso' ,fechaIngreso : moment().format('YYYY-MM-DD') };
            }
        },
        provide(){
            return{
                resetModal: this.resetModal,
                setData: this.setData
            }
        }
    }
</script>